var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFixture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.66016H6V28.6602H24V9.66016Z",
    fill: "#DCDCE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26.6602H16L16 12.6602H22V26.6602Z",
    fill: "url(#paint0_linear_8459_50378)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.6602H8L8 12.6602H14L14 26.6602Z",
    fill: "url(#paint1_linear_8459_50378)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00635 9.66016C3.96214 8.49492 4.14909 7.33257 4.55601 6.24274C4.96294 5.15292 5.58146 4.15803 6.37453 3.31768C7.1676 2.47733 8.1189 1.80881 9.17144 1.35217C10.224 0.895527 11.3561 0.660156 12.5 0.660156C13.6439 0.660156 14.776 0.895527 15.8286 1.35217C16.8811 1.80881 17.8324 2.47733 18.6255 3.31768C19.4185 4.15803 20.0371 5.15292 20.444 6.24274C20.8509 7.33257 21.0379 8.49492 20.9936 9.66016",
    fill: "#DCDCE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.660156H12V9.66016H17V0.660156Z",
    fill: "#DCDCE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00673 9.66016C7.95991 8.49492 8.15786 7.33257 8.58872 6.24274C9.01958 5.15292 9.67449 4.15803 10.5142 3.31768C11.3539 2.47733 12.3612 1.80881 13.4756 1.35217C14.5901 0.895527 15.7888 0.660156 17 0.660156C18.2112 0.660156 19.4099 0.895527 20.5244 1.35217C21.6388 1.80881 22.6461 2.47733 23.4858 3.31768C24.3255 4.15803 24.9804 5.15292 25.4113 6.24274C25.8421 7.33257 26.0401 8.49492 25.9933 9.66016",
    fill: "#DCDCE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.66016H4V12.6602H26V9.66016Z",
    fill: "#AAAAB1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8459_50378",
    x1: 19,
    y1: 17.6602,
    x2: 24.6518,
    y2: 33.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8459_50378",
    x1: 11.4286,
    y1: 20.1602,
    x2: 16.4956,
    y2: 33.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixture);
export default __webpack_public_path__ + "static/media/fixture.ff294ae61704a4bd7e204f256f551508.svg";
export { ForwardRef as ReactComponent };